import {
  Component,
  ElementRef,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
} from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { first } from "rxjs/operators";
import { AuthenticationService } from "src/app/core/services/auth.service";
import { AuthfakeauthenticationService } from "src/app/core/services/authfake.service";
import { EventService } from "src/app/core/services/event.service";
import { ApiService } from "src/app/shared/services/api.service";
import { environment } from "src/environments/environment";
import { TranslateService } from "@ngx-translate/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { of } from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";
declare var $: any;
import * as bootstrap from "bootstrap"; // Import Bootstrap

interface Product {
  name: string;
  quantity: number;
  src: string;
}
@Component({
  selector: "app-new-landing-web",
  templateUrl: "./new-landing-web.component.html",
  styleUrls: ["./new-landing-web.component.scss"],
})
export class NewLandingWebComponent implements OnInit {
  @ViewChildren("navLinks") navLinks: QueryList<ElementRef>;

  panelOpenState = false;
  listProvices;
  phone;
  fullName;
  listProvince;
  note;
  formData!: FormGroup;
  registrationData: any;
  serviceType = "shipper";
  products: Product[] = [
    { name: "wifi", quantity: 1, src: "assets/images/loa_wifi.png" },
    { name: "4g", quantity: 1, src: "assets/images/loa_4g.png" },
  ];
  isMobile;
  currentMonth;
  orderForm: FormGroup;
  constructor(
    private authService: AuthenticationService,
    private formBuilder: FormBuilder,
    private http: HttpClient,
    private route: ActivatedRoute,
    private router: Router,
    private eventService: EventService,
    private apiService: ApiService,
    private translateService: TranslateService,
    public authenticationService: AuthenticationService,
    public authFackservice: AuthfakeauthenticationService,
    private modalService: NgbModal
  ) {
    const now = new Date();
    const monthNames = [
      "Tháng 01",
      "Tháng 02",
      "Tháng 03",
      "Tháng 04",
      "Tháng 05",
      "Tháng 06",
      "Tháng 07",
      "Tháng 08",
      "Tháng 09",
      "Tháng 10",
      "Tháng 11",
      "Tháng 12",
    ];
    this.currentMonth = monthNames[now.getMonth()];

    this.orderForm = this.formBuilder.group({
      storeInfo: this.formBuilder.group({
        storeName: ['', Validators.required],
        terminalPhone: ['', [Validators.required, Validators.pattern(/^\d{10}$/)]],
        province: [null, Validators.required],
        district: [null, Validators.required],
        ward: [null, Validators.required],
        storeAddress: ['', Validators.required],
        qrAccount: ['', Validators.required],
        accountOwner: ['', Validators.required]
      }),
      shippingInfo: this.formBuilder.group({
        recipientName: ['', Validators.required],
        recipientPhone: ['', Validators.required],
        province: [null, Validators.required],
        district: [null, Validators.required],
        ward: [null, Validators.required],
        address: ['', Validators.required]
      }),
    });
    
  }
  @ViewChild("chooseModal") chooseModal: any;
  @ViewChild("searchModal") searchModal: any;
  listDataSearch: any[] = [];
  pageSize = 999;
  pageIndex = 1;
  totalCount = 0;
  productLocal;

  ngOnInit(): void {
    // this.productLocal = JSON.parse(localStorage.getItem("selectedProduct"));

    this.getProvinces();
    this.setActiveProduct(this.products[0]);
    this.fetchData();
    this.formData = this.formBuilder.group({
      fullName: ["", [Validators.required]], // Họ và tên
      phone: ["", [Validators.required, Validators.pattern("^[0-9]{10,11}$")]], // Số điện thoại
      provines: ["", Validators.required], // Tỉnh thành
      note: ["", Validators.required], // Lời nhắn
    });
    this.checkUserDevice();
  }
  sectionValue = 0;
  currentSection;
  sectionTitles;
  async nextSection() {
    if (this.sectionValue === 1 && !this.selectedPackageId) {
      this.apiService.showToastMobile(
        "warning",
        this.translateService.instant("Vui lòng chọn gói dịch vụ")
      );
      return;
    }

    if (this.sectionValue === 2) {
      const success = await this.processPayment();
      if (!success) return;
    }

    window.scrollTo({ top: 0, behavior: "smooth" });
    this.sectionValue++;
  }

  previousSection() {
    this.sectionValue--;
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
  onInputChange(event: Event, controlName: string): void {
    const input = event.target as HTMLInputElement;
    const sanitizedValue = input.value.replace(/[^\p{L}\p{N}\s]/gu, "");

    // Cập nhật giá trị của control tương ứng
    this.orderForm
      .get(controlName)
      ?.setValue(sanitizedValue, { emitEvent: false });
  }
  isTermsAgreed: boolean = true;
  selectedProvince: any = -1;
  selectedDistrict: any = -1;
  selectedWard: any = -1;
  listDistrict: any[] = []; // Danh sách các quận/huyện
  listWard: any[] = []; // Danh sách các xã/phường
  getProvinces() {
    this.apiService.getList("viettel-post/province?provinceId=-1").subscribe({
      next: (res) => {
        this.listProvince = res;
      },
    });
  }
  
  onProvinceChange(province: any, group: string) {
    this.apiService
      .getList("viettel-post/district?provinceId=" + province?.PROVINCE_ID)
      .subscribe({
        next: (res) => {
          this.listDistrict = res;
          if (group === 'storeInfo') {
            this.orderForm.get('storeInfo.district').setValue(null);
            this.orderForm.get('storeInfo.ward').setValue(null);
          } else if (group === 'shippingInfo') {
            this.orderForm.get('shippingInfo.district').setValue(null);
            this.orderForm.get('shippingInfo.ward').setValue(null);
          } 
        },
      });
    this.listWard = [];
  }
  
  onDistrictChange(district: any, group: string) {
    this.apiService
      .getList("viettel-post/ward?districtId=" + district.DISTRICT_ID)
      .subscribe({
        next: (res) => {
          this.listWard = res;
          if (group === 'storeInfo') {
            this.orderForm.get('storeInfo.ward').setValue(null);
          } else if (group === 'shippingInfo') {
            this.orderForm.get('shippingInfo.ward').setValue(null);
          }
        },
      });
  }
  onInputBlur() {
    this.eventService.setLoading(true);
    
    // Reset accountOwner trong nhóm storeInfo
    this.orderForm.get('storeInfo').patchValue({ accountOwner: "" });
  
    // Lấy giá trị qrAccount từ storeInfo
    const qrAccountValue = this.orderForm.get("storeInfo.qrAccount")?.value || "";
    if (qrAccountValue === "") {
      this.eventService.setLoading(false);
      return;
    }
  
    // Chuẩn bị dữ liệu gửi API
    const data = {
      terminalBankAcc: qrAccountValue,
    };
  
    // Gọi API để tìm thông tin chủ tài khoản
    this.apiService
      .searchBankaccount("affiliate/account-info", data)
      .subscribe({
        next: (response: any) => {
          this.apiService.showToastMobile(
            this.translateService.instant("success"),
            this.translateService.instant("Tìm kiếm thành công")
          );
          // Cập nhật accountOwner trong storeInfo
          this.orderForm.get('storeInfo').patchValue({
            accountOwner: response?.metadata?.accountInfo.accountName,
          });
          this.eventService.setLoading(false);
        },
        error: (e) => {
          if (e) {
            this.apiService.showToastMobile(
              "error",
              this.translateService.instant(e)
            );
            this.eventService.setLoading(false);
          } else {
            this.apiService.showToastMobile(
              "error",
              this.translateService.instant("Lỗi kết nối. Vui lòng thử lại sau")
            );
            this.eventService.setLoading(false);
          }
        },
      });
  }
  ngAfterViewInit() {
    window.addEventListener("scroll", this.handleScroll.bind(this));
    this.addSmoothScrollToNavLinks();
  }

  handleScroll() {
    const sections = document.querySelectorAll("section");
    const navLinks = this.navLinks.toArray().map((link) => link.nativeElement);

    let activeIndex = -1;
    let maxScrollTop = 0;

    sections.forEach((section, index) => {
      const sectionTop = section.offsetTop;
      const sectionHeight = section.clientHeight;

      if (window.pageYOffset >= sectionTop - sectionHeight / 3) {
        if (window.pageYOffset >= maxScrollTop) {
          maxScrollTop = window.pageYOffset;
          activeIndex = index;
        }
      }
    });

    navLinks.forEach((link, index) => {
      link.classList.remove("active");
      if (index === activeIndex) {
        link.classList.add("active");
      }
    });
  }
  addSmoothScrollToNavLinks() {
    this.navLinks.forEach((link) => {
      link.nativeElement.addEventListener("click", (event: Event) => {
        event.preventDefault();
        const targetId = (event.target as HTMLElement).getAttribute("href");
        const targetElement = document.querySelector(targetId);
        if (targetElement) {
          targetElement.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      });
    });
  }
  checkUserDevice(): void {
    this.isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    if (this.isMobile) {
      console.log("User is on a mobile device");
    } else {
      console.log("User is on a desktop/laptop computer");
    }
  }

  fetchData() {
    const name = this.selectedProduct.name
      ? this.selectedProduct.name
      : JSON.parse(localStorage.getItem("selectedProduct"))?.name;
    this.apiService.getList("service-package?type=affiliate&device_name=" + name).subscribe({
      next: (res) => {
        this.packages = res["metadata"]["packages"]
          ? res["metadata"]["packages"]
          : [];
        this.selectPackage(
          this.activeProduct.name === "4g" ? this.packages[4] : this.packages[1]
        );
      },
    });
  }
  isPlaying = false;
  audio = new Audio("assets/audio/File_test.mp3");
  playAudio() {
    if (this.isPlaying) {
      this.audio.pause();
      this.isPlaying = false;
    } else {
      this.audio.play();
      this.isPlaying = true;
      this.audio.onended = () => {
        this.isPlaying = false;
      };
    }
  }
  selectedProduct: { name: string; quantity: number; src: any } | null = null;
  quantities: { [key: string]: number } = {
    wifi: 1,
    "4g": 1,
  };
  selectProduct(product: any) {
    this.selectedProduct = product;
    $("#chooseDetails").modal("show"); // Hiện modal bằng jQuery
  }
  activeProduct: Product | null =
    this.products.find((product) => product.name === "wifi") || null;
  isFirstCall = true;

  setActiveProduct(product: Product): void {
    if (this.isFirstCall) {
      this.selectedProduct = {
        name: product.name,
        quantity: this.quantities[product.name],
        src: product.src,
      };
      this.isFirstCall = false;
    } else {
      this.selectedProduct = {
        name: product.name,
        quantity: this.quantities[product.name],
        src: product.src,
      };
    }
    this.fetchData();
    this.selectedPackageId = product.name === "4g" ? 5 : 2;
  }

  changeQuantity(product: Product, change: number): void {
    const newQuantity = this.quantities[product.name] + change;
    if (newQuantity > 0) {
      this.quantities[product.name] = newQuantity;
      if (this.selectedProduct?.name === product.name) {
        this.selectedProduct.quantity = newQuantity;
      }
    }
    console.log(this.selectedProduct);
  }
  isChecked: boolean = true;
  toggleSwitch(event: any) {
    this.isChecked = event;
    if (this.isChecked) {
      const storeInfo = this.orderForm.get('storeInfo').value;
      this.orderForm.get('shippingInfo').patchValue({
        recipientName: storeInfo.storeName,
        recipientPhone: storeInfo.terminalPhone,
        province: storeInfo.province,
        district: storeInfo.district,
        ward: storeInfo.ward,
        address: storeInfo.storeAddress,
      });
    }
  }

  selectedPackage;
  packages;
  selectedPackageId: number | null = 2;
  selectPackage(packages) {
    if (this.selectedPackageId === packages.id) {
      this.selectedPackageId = null;
      this.selectedPackage = null;
    } else {
      this.selectedPackageId = packages.id;
      this.selectedPackage = packages;
    }
  }
  onCheckboxChange(event: Event) {
    const checkbox = event.target as HTMLInputElement;
    this.isTermsAgreed = checkbox.checked;
  }

  openLink(): void {
    this.checkUserDevice();
    if (this.isMobile) {
      window.location.href = "mbbank://?ad_dp=marketplaceapp&code=PHZTOMOTEK";
    } else {
      const modalElement = this.chooseModal.nativeElement;
      const modal = new bootstrap.Modal(modalElement);
      modal.show();
    }
  }
  openSearch(): void {
    this.formData = this.formBuilder.group({
      fullName: ["", [Validators.required]],
      note: ["", Validators.required],
    });
    const modalElement = this.searchModal.nativeElement;
    const modal = new bootstrap.Modal(modalElement);
    modal.show();
  }
  saveToLocalStorage(): void {
    if (this.selectedProduct) {
      localStorage.setItem(
        "selectedProduct",
        JSON.stringify(this.selectedProduct)
      );
    } else {
      console.log("No product selected.");
    }
  }
  viewDetailsViettel() {
    const url = `https://viettelpost.com.vn/tra-cuu-hanh-trinh-don/`;
    window.open(url, "_blank");
  }

  handleOffline() {
    localStorage.setItem("serviceType", "direct");
    this.router.navigate(["/account/web-form-page"]).then(() => {
      document.querySelector(".modal-backdrop")?.remove();
      document.body.classList.remove("modal-open");
      document.body.style.overflow = "";
    });
  }

  handleOnline() {
    localStorage.setItem("serviceType", "shipper");
    this.router.navigate(["/account/web-form-page"]).then(() => {
      document.querySelector(".modal-backdrop")?.remove();
      document.body.classList.remove("modal-open");
      document.body.style.overflow = "";
    });
  }
  viewDetails(data) {
    const orderCode = data.order_code;
    // const url = `https://tracking.ghn.dev/?order_code=${orderCode}`; --dev
    const url = `https://donhang.ghn.vn/?order_code=${orderCode}`; //prod
    window.open(url, "_blank");
  }
  saveData() {
    const data = {
      phone: this.formData.value.phone,
      full_name: this.formData.value.fullName,
      feedback: this.formData.value.note,
      province: this.formData.value.provines,
    };
    this.apiService.addItem("customer-feedback", data).subscribe({
      next: (res) => {
        this.apiService.showToast(
          this.translateService.instant("Thành công"),
          this.translateService.instant("Đăng ký thành công"),
          "success"
        );
        this.eventService.setLoading(false);
        this.modalService.dismissAll();
      },
      error: (e) => {
        this.apiService.showToast(
          this.translateService.instant("FORM.Error"),
          this.translateService.instant("FORM.ErrorMessageAdd"),
          "error"
        );
        this.eventService.setLoading(false);
      },
    });
  }
  flagHide = false;
  inProgress = false;
  dataOrder;
  isLoading = false;
  processPayment(): Promise<boolean> {
    return new Promise((resolve) => {
      this.isLoading = true;
      if (this.inProgress) return resolve(false);
      this.inProgress = true;
  
      if (!this.isTermsAgreed) {
        this.apiService.showToastMobile(
          this.translateService.instant("warning"),
          this.translateService.instant("Vui lòng đồng ý với điều khoản dịch vụ.")
        );
        this.isLoading = false;
        this.inProgress = false;
        return resolve(false);
      }
  
      if (!this.orderForm.valid) {
        this.showValidationErrors();
        this.isLoading = false;
        this.inProgress = false;
        return resolve(false);
      }
  
      let storeCreationObservable;
  
      if (this.orderForm.value.selectedStore) {
        storeCreationObservable = of({
          metadata: { workspaceId: this.orderForm.value.selectedStore },
        });
      } else {
        const storeInfo = this.orderForm.value.storeInfo;
        const data = {
          name: storeInfo.storeName,
          terminalAddress: storeInfo.storeAddress,
          terminalBankAcc: storeInfo.qrAccount,
          terminalBankName: "970422",
          terminalPhone: storeInfo.terminalPhone,
          terminalBankAccountName: storeInfo.accountOwner,
          terminalWard: storeInfo.ward?.WARDS_NAME || "",
          terminalWardId: storeInfo.ward?.WARDS_ID || "",
          terminalDistrict: storeInfo.district?.DISTRICT_NAME || "",
          terminalDistrictId: storeInfo.district?.DISTRICT_ID || "",
          terminalProvince: storeInfo.province?.PROVINCE_NAME || "",
          terminalProvinceId: storeInfo.province?.PROVINCE_ID || "",
        };
  
        storeCreationObservable = this.apiService.addItem(
          "affiliate/create-workspace",
          data
        );
      }
  
      storeCreationObservable.subscribe({
        next: (res) => {
          const shippingInfo = this.orderForm.value.shippingInfo;
          const packageData = {
            isSameAddress: this.isChecked,
            workspaceId: res["metadata"]?.workspaceId,
            packageId: this.selectedPackageId,
            quantity: this.selectedProduct?.quantity,
            customerName: shippingInfo.recipientName,
            phone: shippingInfo.recipientPhone,
            address: shippingInfo.address,
            wardName: shippingInfo.ward?.WARDS_NAME || "",
            wardName_id: shippingInfo.ward?.WARDS_ID || "",
            districtName: shippingInfo.district?.DISTRICT_NAME || "",
            districtName_id: shippingInfo.district?.DISTRICT_ID || "",
            provinceName: shippingInfo.province?.PROVINCE_NAME || "",
            provinceName_id: shippingInfo.province?.PROVINCE_ID || "",
            deliveryMethod: this.serviceType,
          };
  
          this.apiService
            .postItem("affiliate/create-order", packageData)
            .subscribe({
              next: (res: any) => {
                this.dataOrder = res.metadata;
                this.inProgress = false;
                this.statusInterval = setInterval(() => {
                  this.checkOrderStatus();
                }, 5000);
                this.isLoading = false;
                resolve(true);
              },
              error: (e) => {
                this.inProgress = false;
                this.isLoading = false;
                resolve(false);
              },
            });
        },
        error: (e) => {
          this.apiService.showToastMobile(
            "error",
            this.translateService.instant(e || "Tạo cửa hàng thất bại")
          );
          this.inProgress = false;
          this.eventService.setLoading(false);
          resolve(false);
        },
      });
    });
  }
  paymentStatus: "pending" | "success" = "pending";
  statusInterval: any;

  checkOrderStatus() {
    const payload = {
      billNumber: this.dataOrder?.billNumber,
    };

    this.apiService
      .postItem("affiliate/check-status-order", payload)
      .subscribe({
        next: (res: any) => {
          if (res?.metadata?.isPaid) {
            clearInterval(this.statusInterval);
            this.paymentStatus = "success";
            this.apiService.showToastMobile(
              "success",
              "Thanh toán thành công!"
            );
          }
        },
        error: (err) => {
          console.error("Lỗi kiểm tra trạng thái đơn hàng:", err);
        },
      });
  }

  private showValidationErrors(): void {
    const formControls = this.orderForm.controls;
    const formControlNames = Object.keys(formControls);

    for (const controlName of formControlNames) {
      const control = formControls[controlName];

      if (control.invalid) {
        if (
          this.isChecked &&
          ["province", "district", "ward", "address"].includes(controlName)
        ) {
          continue;
        }

        const errors = control.errors;
        for (const errorKey in errors) {
          if (errors.hasOwnProperty(errorKey)) {
            let errorMessage: string;
            switch (controlName) {
              case "storeName":
                errorMessage = "Tên cửa hàng là bắt buộc.";
                break;
              case "storeAddress":
                errorMessage = "Địa chỉ cửa hàng là bắt buộc.";
                break;
              case "qrAccount":
                errorMessage = "Tài khoản QR là bắt buộc.";
                break;
              case "accountOwner":
                errorMessage = "Chủ tài khoản là bắt buộc.";
                break;
              case "recipientName":
                if (this.serviceType === "shipper") {
                  errorMessage = "Tên người nhận là bắt buộc.";
                } else {
                  continue;
                }
                break;
              case "recipientPhone":
                if (this.serviceType === "shipper") {
                  const phoneErrors = control.errors;
                  if (phoneErrors?.required) {
                    errorMessage = "Số điện thoại là bắt buộc.";
                  }
                  if (phoneErrors?.pattern) {
                    errorMessage = "Số điện thoại không hợp lệ.";
                  }
                } else {
                  continue;
                }
                break;
              case "province":
              case "district":
              case "ward":
              case "address":
                if (this.serviceType === "shipper") {
                  errorMessage = "Thông tin địa chỉ là bắt buộc.";
                } else {
                  continue;
                }
                break;
              case "pattern":
                errorMessage = "Thông tin không hợp lệ.";
                break;
              default:
                errorMessage = "Có lỗi trong thông tin.";
                break;
            }

            if (errorMessage) {
              this.apiService.showToastMobile(
                this.translateService.instant("warning"),
                errorMessage
              );
            }
            break;
          }
        }
      }
    }
  }
}
